export default __webpack_public_path__ + "static/media/sepehr_saberian.70f95de2.jpeg";